/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
*/
import React, {PropsWithChildren} from 'react';

export interface TabContainerProps {
  tabIndex?: Number;
  key?: string;
}

/**
 * Provides a container for a dialog tab. Ensures tab sizes in a dialog remain consistent.
 */
export const TabContainer = ({
  children,
  key = 'tabContainer',
  tabIndex = 0
}: PropsWithChildren<TabContainerProps>) => (
  <div id={`${key}_${tabIndex}`}>
    {children}
  </div>
);

export default TabContainer;
